import { observer } from 'mobx-react-lite'
import { useLoaderData } from 'react-router'
import { StripeCallback } from '@/features/billing/stripe-connect/StripeCallback'
import { ContentError } from '@/components/ContentError'
import type { StripeCallbackLoaderData } from '@/features/billing/stripe-connect/stripe-connect-route-loaders'

export default observer(function StripeCallbackContainer() {
  // The route loader redirects away unless the callback failed.
  const { error } = useLoaderData<StripeCallbackLoaderData>()

  return (
    <StripeCallback>
      <ContentError error={error} />
    </StripeCallback>
  )
})
